import { RefreshCw, Sparkles } from 'lucide-react';
import { usePWA } from '../hooks/usePWA';

export default function PWAUpdateNotification() {
  const { needRefresh, updateApp } = usePWA();

  if (!needRefresh) {
    return null;
  }

  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-100 max-w-md w-[92%] sm:w-auto animate-in fade-in slide-in-from-top-4 duration-300">
      <div className="bg-slate-900/95 backdrop-blur-md border border-purple-500/30 text-white p-3 sm:px-4 sm:py-3 rounded-2xl shadow-2xl flex items-center justify-between gap-3 sm:gap-4">
        <div className="flex items-center gap-2.5">
          <div className="p-2 rounded-xl bg-purple-500/20 text-purple-400">
            <Sparkles className="w-4 h-4" />
          </div>
          <div>
            <p className="text-xs font-bold text-slate-100">Update Available</p>
            <p className="text-[11px] text-slate-400 hidden sm:block">
              A newer version of PesaJet Pay is available.
            </p>
          </div>
        </div>
        <button
          onClick={updateApp}
          className="px-3 py-1.5 bg-gradient-to-r from-purple-700 to-purple-600 hover:from-purple-600 hover:to-purple-500 text-white text-xs font-bold rounded-xl flex items-center gap-1.5 shadow-md transition shrink-0"
        >
          <RefreshCw className="w-3.5 h-3.5" />
          Update Now
        </button>
      </div>
    </div>
  );
}
